import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Col, Table } from "react-bootstrap";

import { BsFillCircleFill } from "react-icons/bs";

const ComplianceTable = ({ data }) => {
  const getRowDataLabels = (row) => {
    return row.values.map((element, index) => {
      if (element.label === null) return;
      return (
        <td key={index} className="text-center">
          {element.label}
        </td>
      );
    });
  };

  const getRowDataState = (row) => {
    if (row.values.length === 1)
      switch (row.values[row.values.length - 1].state) {
        case 0:
          return (
            <td className="text-center" colSpan={3}>
              <BsFillCircleFill color="green" />
            </td>
          );
        case 1:
          return (
            <td className="text-center" colSpan={3}>
              <BsFillCircleFill color="yellow" />
            </td>
          );
        case 2:
          return (
            <td className="text-center" colSpan={3}>
              <BsFillCircleFill color="red" />
            </td>
          );
        default:
          return <td className="text-center"></td>;
      }
    else
      return row.values.map((element1, index) => {
        switch (element1.state) {
          case 0:
            return (
              <td key={index} className="text-center">
                <BsFillCircleFill color="green" />
              </td>
            );
          case 1:
            return (
              <td key={index} className="text-center">
                <BsFillCircleFill color="yellow" />
              </td>
            );
          case 2:
            return (
              <td key={index} className="text-center">
                <BsFillCircleFill color="red" />
              </td>
            );
          default:
            return <td key={index} className="text-center"></td>;
        }
      });
  };

  const getRowsData = () => {
    return data.map((row, index) => {
      return (
        <React.Fragment key={index}>
          <tr>
            <td className="text-center" rowSpan={2}>
              {row.kpiLabel}
            </td>
            {getRowDataLabels(row)}
          </tr>
          <tr>{getRowDataState(row)}</tr>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <Col md={{ span: 8, offset: 2 }}>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th
                className="text-center"
                width="40%"
                style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                colSpan={1}
              >
                KPI
              </th>
              <th className="text-center" colSpan={10}>
                Compliance
              </th>
            </tr>
          </thead>
          <tbody>{getRowsData()}</tbody>
        </Table>
      </Col>
    </>
  );
};

export default ComplianceTable;
